import { BasicRequest } from "./basicRequest";

export class ToggleMoovExecutionStatusRequest extends BasicRequest{
    public executingMoovs:boolean=false;
}